import React from 'react'
import CommonNotificationSettingChange from '../../../common/pages/secure/NotificationSettingChange'
import PageHeader from '../../components/PageHeader'

class NotificationSettingChange extends CommonNotificationSettingChange {
  constructor (props) {
    super(props)
    this.userRoleUrl = 'company_user'
    this.userRole = 'companyUser'
  }
  renderPageNavi () {
    return (
      <PageHeader title='通知受信可否設定の変更' sub='こちらでお知らせメールの通知受信可否が設定できます。' history={this.props.history}>
        <ul className='nav nav-pills kw-page-actions'>
          <li className='kw-btn-area'><button rel='tooltip' data-placement='left' title='戻る' className='text-center kw-btn-primary' onClick={(e) => this.onPageMenuClicked('back')}><i className='icon-arrow-left icon-large' /><span>戻る</span></button></li>
        </ul>
      </PageHeader>
    )
  }
}

export default NotificationSettingChange



// WEBPACK FOOTER //
// ./src/company_user/pages/secure/NotificationSettingChange.js